<div *ngIf="!deviceUrl" class="no-device-message" style="margin-left: 15px;">
  <span class="device-badge">
    <i class="pi pi-link"></i> {{ 'SELECT_DEVICE_FIRST' | translate }}
  </span>
</div>

<div *ngIf="deviceUrl" class="device-info" style="margin-left: 15px;">
  <span class="device-badge">
    <i class="pi pi-link"></i> {{ 'DEVICE_SELECTED' | translate }}: {{ deviceUrl }}
  </span>
</div>
